module.exports = __webpack_public_path__ + "static/media/KaWineAndDine_Badge_shops.a6bf61c0.jpg";